/**
 * https://wiki.yandex-team.ru/velocity/rum/#standartnyemetkivremeni
 * https://stat.yandex-team.ru/DictionaryEditor/BlockStat
 *
 * При добавлении сюда новых значений, также нужно их добавить в `CodeToNameMap` в `debugger.ts`
 */
export enum Counter {
  /** Момент инициализации реакта */
  ReactInited = '3872',
  /** Момент окончания исполнения основного файла */
  MainJS = '2095',
  /** Момент начала исполнения основного файла */
  Start = '2154',
  /** Основной контент страницы */
  Hero = '2876'
}
